import InfoCircle from '../src/InfoCircle/index.tsx';
export default InfoCircle;
